import { render, staticRenderFns } from "./SignActivityEdit.vue?vue&type=template&id=dee27af8&scoped=true"
import script from "./SignActivityEdit.vue?vue&type=script&lang=js"
export * from "./SignActivityEdit.vue?vue&type=script&lang=js"
import style0 from "./SignActivityEdit.vue?vue&type=style&index=0&id=dee27af8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee27af8",
  null
  
)

export default component.exports